import { ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/assessment-overview/questionnaireAnswer'
import { PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/patient-overview/questionnaireAnswer'
import { MEDICATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/medications/questionnaireAnswer'
import { MEDICAL_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/medical-background/questionnaireAnswer'
import { DISCHARGE_SUMMARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/discharge-summary/questionnaireAnswer'
import { DISCHARGE_FINAL_STEP_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/final-steps/questionnaireAnswer'

// Amalgamate all section questionnaire answer type mappings
export const DISCHARGE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  ...ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...MEDICATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...MEDICAL_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...DISCHARGE_SUMMARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...DISCHARGE_FINAL_STEP_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
